import { render, staticRenderFns } from "./FormQuestionBlockGeneralSettings.vue?vue&type=template&id=1ff4b370"
import script from "./FormQuestionBlockGeneralSettings.vue?vue&type=script&lang=js"
export * from "./FormQuestionBlockGeneralSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports